export default {"src":"/_next/static/media/fct.43af0d6a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};